module.exports = __webpack_public_path__ + "static/media/1.fa3b166d.png";